<div class="container-fluid">
    <div class="row" id="docPage">
        <div class="gc_tool">
            
            <div id="content" class="addfortesting">
            
                <app-sidebar></app-sidebar>
            
                <div class="gc_textpad">
            
                    <div id="mm" class="gc_text" data-placeholder="Start typing your text or paste your text here"
                        contenteditable="true" spellcheck="false" data-gramm="false">
                        <h4>Type or paste (Ctrl+V) your text here</h4>
                        <p id="uploadcontent">Or , upload a document. (Maximum 10,000 words allowed per query)</p>
                        <button style="background-color: black;
                 width: 147px;
                 height: 48px;
                 border-radius: 5px;"><img src="../../assets/images/editorimages/uploadfile.svg" style="height: 19px;
width: 99px;margin-top: -11px;"></button> <img src="../../assets/images/editorimages/dropbox.svg" style=" margin-top: -13px;
margin-left: 10px;"> <img src="../../assets/images/editorimages/gdrive.svg" style=" margin-top: -13px;
margin-left: 10px;">
                    </div>
            
                    <div id="count-word" class="float-left">
                        <div class="count_Con d-inline-block mr-5"> <span id="char_count" class="word_count"></span>
                            <span class="total_word font-weight-bold ml-2">
                                Words: 0 / 2000 | Total Character: 0 | Reading Time: 0 min
                            </span> <span id="savefiletextsonly" class="bg-saved p-2 ml-2">

                            </span> </div>
                    </div>
                    <div> <span id="clear-text" class="clear_text ml-2 clear_text_dark">
                            <img src="../../assets/images/grammar checker/clear text.svg">
                            Clear Text
                        </span> </div>
                    <div> </div>
                </div>
            </div>
        </div>
    </div>
</div>